<template>
  <a :href="content.menu.original" download target="_blank" class="text-center square-card">
    <div class="image__block">
      <Image :source="content.image" class="--square-card" />
      <Icon id="roundArrow" class="square-card__icon" />
    </div>
    <h3 class="square-card__title heading --card">{{ content.name }}</h3>
    <p>{{ content.note }}</p>
  </a>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import HasContentProp from '@/mixins/HasContentProp'

export default {
  name: 'MenuCard',
  mixins: [HasContentProp],
  components: {
    Icon,
    Image,
  },
}
</script>
